import { useCookies } from 'react-cookie';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated, markSessionExpiredNotice } from '../authSession';
import { clearAuthSession } from '../services/serviceconfig';
import SessionTimeoutMonitor from './SessionTimeoutMonitor';

export default function AuthGuard() {
  const [cookies] = useCookies(['myToken']);
  const authenticated = isAuthenticated(cookies);

  if (!authenticated) {
    if (cookies?.myToken) {
      markSessionExpiredNotice();
      clearAuthSession();
    }
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <SessionTimeoutMonitor />
      <Outlet />
    </>
  );
}
